import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar sticky-top navbar-expand-lg navbar-light bg-body" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/atsthlmlogo-1024x713.png",
  height: "80"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbar",
  "aria-controls": "navbar",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars fa-sm" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbar"
}
const _hoisted_6 = {
  class: "navbar-nav ms-auto my-2 my-lg-0",
  style: {"--bs-scroll-height":"100px"}
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Boka tid")
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Kontakt")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Hitta oss")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "https://www.instagram.com/at.stockholm/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/boka"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/home#kontakt"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/home#hittaoss"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _hoisted_13
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ]))
}